export * from '../ext-core/ext-msg';
import {
  ErrorCode as HttpErrorCode,
  VoiceErrorCode,
} from '@hellopearl/iso-voice-models';
export {
  ok,
  fail,
  createSuccessResult,
  createFailureResult,
  isSuccessResult,
  isFailureResult,
  normalizeToResult,
  VoiceErrorCode,
} from '@hellopearl/iso-voice-models';
export type {
  ErrorCodeValue,
  AppError,
  SuccessResult,
  FailureResult,
  AppResult,
} from '@hellopearl/iso-voice-models';

/**
 * Unified error code enum merging HTTP-level codes (iso-http) with
 * voice-domain codes (VoiceErrorCode) so existing consumers that rely
 * on `ErrorCode.PatientMismatch` etc. keep working.
 */
export const ErrorCode = Object.freeze({
  ...HttpErrorCode,
  ...VoiceErrorCode,
} as typeof HttpErrorCode & typeof VoiceErrorCode);
